import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link, useLocation } from "react-router-dom"
// import queryString from 'query-string';
import {
  Row,
  Col,
  BreadcrumbItem,
  Label,
  InputGroup,
  CardBody,
  Card,
  Form,
} from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { getAuthUsers as onGetAuthUser } from "store/actions"
import { GET_AUTH_USERS_DESIGNER, GET_AUTH_USERS_SALES } from "helpers/url_helper"
import { size } from "lodash"


const FilterComponentForCustomers = props => {
  const { handleFilterClick, filter } = props

  const location = useLocation()

  const dispatch = useDispatch()

  const { designerUsers, salesUsers } = useSelector(state => ({
    designerUsers: state.Login.designers,
    salesUsers: state.Login.sales,
  }))


  const [formState, setFormState] = useState({
    email: "",
    sales: { value: "", label: "All Sales" },
    designer: { value: "", label: "All Designers" },
    colorStatus: { value: "", label: "All" },
    paymentStatus: { value: "", label: "All" },
    orderDate: [],
  })


  const [designer, setDesigner] = useState([
    { value: "", label: "All Designers" },
  ])
  const [sales, setSales] = useState([
    { value: "", label: "All Sales" },
  ])
  const colorOptions = [
    { value: "", label: "All" },
    { value: "Green", label: "Green" },
    { value: "Red", label: "Red" },
  ]
  const paymentStatus = [
    { value: "", label: "All" },
    { value: true, label: "Paid" },
    { value: false, label: "Payable" },
  ]

  const assToSalesManOptions = [
    { value: "", label: "All" },
    // { value: "designer1", label: "Designer One" },
    // { value: "designer2", label: "Designer Two" },
    // { value: "designer3", label: "Designer Three" },
  ]


  const [orderStatus, setOrderStatus] = useState([
    { value: "", label: "All Status" },
    { value: "Done", label: "Done" },
  ])



  useEffect(() => {
    if (!("docs" in designerUsers)) {
      const filter = { Designation: "designer"}
      const prop = {size:100, page:1} 
      dispatch(onGetAuthUser({prop,filter, url: GET_AUTH_USERS_DESIGNER}))
    } else {
      console.log("designerUsers", designerUsers)
      setDesigner(formatJson(designerUsers, "All Designers"))
    }
   }, [dispatch, designerUsers])

  useEffect(() => {
    if (!("docs" in salesUsers)) {
      const filter = { Designation: "sales"}
      const prop = {size:100, page:1} 
      dispatch(onGetAuthUser({prop, filter, url: GET_AUTH_USERS_SALES }))
    } else {
      setSales(formatJson(salesUsers, "All Sales"))
    }
  }, [dispatch, salesUsers])

  function formatJson(data, lable) {
    const formattedData = data.docs.map(item => ({
      value: item.userName,
      label: item.customerNick,
    }))
    formattedData.unshift({ value: "", label: lable })
    return formattedData
  }

  // const page = window.location.pathname

  // const queryParams = new URLSearchParams(location.search)

  const handleInputChange = e => {
    const { id, value } = e.target
    setFormState(prevState => ({
      ...prevState,
      [id]: value.trim(),
    }))
  }

  const handleSelectChange = (selectedOption, type) => {
    // console.log("selectedOption", selectedOption, type)
    setFormState(prevState => ({
      ...prevState,
      [type]: selectedOption,
    }))
  }

  const handleDateChange = selectedDates => {
    const dates = selectedDates.map(date => new Date(date).toISOString())
    setFormState(prevState => ({
      ...prevState,
      orderDate: dates,
    }))
  }

  return (
    <Card>
      <CardBody className="row gy-3 gx-4 align-items-center">
        {/* <h5 className="col-sm-2 mt-2">Search Record</h5> */}

        <div className="col-sm-2">
          <Label className="visually-hidden" htmlFor="email">
            Search By Email
          </Label>
          <InputGroup>
            <div className="input-group-text">@</div>
            <input
              type="text"
              className="form-control"
              id="email"
              placeholder="Search By Email"
              value={formState.email || ""}
              onChange={handleInputChange}
            // onChange={e => setOrderName(e.target.value.trim())}
            />
          </InputGroup>
        </div>
        <div className="col-sm-2">
          <Label className="visually-hidden" htmlFor="email">
            Search By Name
          </Label>
          <InputGroup>
            {/* <div className="input-group-text">@</div> */}
            <input
              type="text"
              className="form-control"
              id="contactPerson"
              placeholder="Search By Contact Person"
              value={formState.contactPerson || ""}
              onChange={handleInputChange}
            // onChange={e => setOrderName(e.target.value.trim())}
            />
          </InputGroup>
        </div>
         {JSON.parse(localStorage.getItem("authUser")).user.Designation === "Administrate" ? (
        <>
        <div className="col-sm-2">
          <Select
            value={formState.sales}
            transition
            onChange={e => handleSelectChange(e, "sales")}
            options={sales}
            placeholder="Sales Person"
            classNamePrefix="select2-selection"
          />
        </div>
        <div className="col-sm-2">
          <Select
            value={formState.designer}
            transition
            onChange={e => handleSelectChange(e, "designer")}
            options={designer}
            placeholder="Designer"
            classNamePrefix="select2-selection"
          />
        </div>
        </>
        ) : ""}

        {location.pathname !== "/customers" && location.pathname !== "/all-customers" ? (
          <div className="col-sm-2">
          <Select
            value={formState.paymentStatus}
            transition
            onChange={e => handleSelectChange(e, "paymentStatus")}
            options={paymentStatus}
            placeholder="Status"
            classNamePrefix="select2-selection"
          />
        </div>
        ):""}
        

  

        <div className="col-sm-2">
          <Label className="visually-hidden" htmlFor="autoSizingInputGroup">
            Search By Order Date
          </Label>
          <InputGroup>
            <div className="input-group-text">@</div>
            
            <Flatpickr
              className="form-control d-block"
              placeholder="dd M,yyyy"
              value={formState.orderDate}
              onChange={handleDateChange}
              options={{
                mode: "range",
                dateFormat: "Y-m-d",
              }}
            />
          </InputGroup>
        </div>

        <div className="col-sm-2">
          <button
            type="submit"
            className="btn btn-primary w-md col-sm-12"
            onClick={() => {
              handleFilterClick(formState)
            }}
          >
            {/*  */}
            Submit
          </button>
        </div>
        {/* </Form> */}
      </CardBody>
    </Card>
  )
}

FilterComponentForCustomers.propTypes = {
  handleFilterClick: PropTypes.func,
  filter: PropTypes.object,
}

export default FilterComponentForCustomers
